var _defs, _line, _line2, _rect, _rect2, _rect3, _rect4, _line3, _line4, _rect5, _rect6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnderLine01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/1000/svg",
    viewBox: "0 0 806.72 28.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#86d1d7;stroke-miterlimit:10;}.cls-2{fill:#86d1d7;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 50.78,
    y1: 3.11,
    x2: 390.53,
    y2: 3.11
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.62,
    y1: 13.86,
    x2: 338.92,
    y2: 13.86
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 394.29,
    y: 4.79,
    width: 18.14,
    height: 18.14,
    transform: "translate(127.94 -281.16) rotate(45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 371.54,
    y: 16.04,
    width: 10.52,
    height: 10.52,
    transform: "translate(125.43 -260.2) rotate(45)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.52,
    y: 10.19,
    width: 7.34,
    height: 7.34,
    transform: "translate(11.32 0.39) rotate(45)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48.15,
    y: 0.91,
    width: 4.4,
    height: 4.4,
    transform: "translate(16.95 -34.69) rotate(45)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 755.94,
    y1: 3.11,
    x2: 416.19,
    y2: 3.11
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 801.1,
    y1: 13.86,
    x2: 467.8,
    y2: 13.86
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 424.66,
    y: 16.04,
    width: 10.52,
    height: 10.52,
    transform: "translate(748.98 -267.64) rotate(135)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 797.85,
    y: 10.19,
    width: 7.34,
    height: 7.34,
    transform: "translate(1378.09 -543.1) rotate(135)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 754.17,
    y: 0.91,
    width: 4.4,
    height: 4.4,
    transform: "translate(1293.41 -529.52) rotate(135)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderLine01);
export default __webpack_public_path__ + "static/media/UnderLine-01.585970a72987517ada86530629ad0cdb.svg";
export { ForwardRef as ReactComponent };